import React from "react";

/**
 * Themed illustrations for each dashboard module — v3 (3D clay renders).
 *
 * Real images are generated once via /app/backend/generate_module_art.py
 * using Gemini Nano Banana, saved to /app/frontend/public/module-art/{key}.png.
 * They ship as static assets with the frontend build (no API call at runtime).
 *
 * The wrapper accepts a `style` prop carrying `color: <accent>` so the per-card
 * accent glow underneath the image picks up the right color.
 */

export function ModuleArt({ moduleKey, className = "", style }) {
  // Each illustration lives at /module-art/{key}.png (served from public/).
  // We add a class for the float animation; CSS handles staggered timing.
  return (
    <span
      className={
        "absolute right-1 top-1 sm:right-2 sm:top-2 pointer-events-none " +
        "transition-all duration-500 hub-art-float " + className
      }
      style={style}
      aria-hidden
    >
      <img
        src={`/module-art/${moduleKey}.png`}
        alt=""
        width={130}
        height={130}
        loading="lazy"
        decoding="async"
        onError={(e) => { e.currentTarget.style.display = "none"; }}
        className="w-[110px] h-[110px] sm:w-[130px] sm:h-[130px] object-contain"
        style={{
          // Soft accent-tinted drop shadow so the picture feels grounded in
          // the card and blends with the per-module color.
          filter: "drop-shadow(0 12px 18px rgba(0,0,0,0.45)) drop-shadow(0 0 14px color-mix(in srgb, currentColor 50%, transparent))",
        }}
      />
    </span>
  );
}
